// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs[data-v-c3c4fe4c] {\n  border: none;\n  height: 100%;\n}\n.tabs[data-v-c3c4fe4c]  .el-tabs__content {\n  padding: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
